// extracted by mini-css-extract-plugin
module.exports = {"VerdictTitleWrapper":"Verdict_VerdictTitleWrapper__2ysQJ","VerdictDescriptionWrapper":"Verdict_VerdictDescriptionWrapper__19KSX"};